import styled from 'styled-components'

import { theme } from '../../constants'

export const SectionContainer = styled.section`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
  position: relative;
  padding: ${theme.spacing[6]};
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.xlarge};
  box-shadow: ${theme.shadows.small};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: ${theme.spacing[6]};
    width: 72px;
    height: 4px;
    background: ${theme.roleColors.student.main};
    border-radius: 0 0 ${theme.radii.pill} ${theme.radii.pill};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing[4]};
  }
`

export const SectionHeader = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${theme.spacing[4]};
  min-width: 0;

  > .section-heading {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: ${theme.spacing[3]};
  }

  .section-heading > div {
    min-width: 0;
  }

  .section-leading-action {
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    display: grid;
    place-items: center;
    padding: 0;
    border: 1px solid ${theme.colors.border};
    border-radius: ${theme.radii.round};
    color: ${theme.colors.textPrimary};
    background: ${theme.colors.surfaceElevated};
    cursor: pointer;

    > svg {
      width: 18px;
      height: 18px;
      display: block;
      color: currentColor;
      fill: currentColor;
    }

    &:hover {
      border-color: ${theme.roleColors.student.main};
      color: ${theme.roleColors.student.text};
      background: ${theme.roleColors.student.soft};
    }

    &:focus-visible {
      outline: 3px solid ${theme.colors.focus};
      outline-offset: 2px;
    }
  }

  h2 {
    margin: 0;
    color: ${theme.colors.textPrimary};
    font-size: ${theme.typography.size.h2};
    line-height: ${theme.typography.lineHeight.heading};
    letter-spacing: -0.025em;
    overflow-wrap: anywhere;
  }

  p {
    margin: ${theme.spacing[1]} 0 0;
    color: ${theme.colors.textMuted};
    font-size: ${theme.typography.size.bodySmall};
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    align-items: flex-start;
    flex-direction: column;

    > .section-heading {
      align-items: center;
    }
  }
`

export const SectionAction = styled.button`
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  padding: ${theme.spacing[2]};
  color: ${theme.roleColors.student.strong};
  background: transparent;
  border: 0;
  border-radius: ${theme.radii.small};
  font-family: inherit;
  font-size: ${theme.typography.size.bodySmall};
  font-weight: ${theme.typography.weight.bold};
  cursor: pointer;

  &:hover {
    background: ${theme.roleColors.student.soft};
  }

  &:focus-visible {
    outline: 3px solid ${theme.roleColors.student.focus};
    outline-offset: 2px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    margin-left: -${theme.spacing[2]};
  }
`

export const SectionContent = styled.div`
  min-width: 0;
`
